import { useEffect, useRef, useState } from 'react';

interface UseIsVisibleOptions {
  rootMargin?: string;
}

// tracks whether an element has ever entered the viewport — once true it stays true,
// so callers can gate an initial fetch without re-fetching every time it scrolls in/out
export function useIsVisible<Element extends HTMLElement>({ rootMargin = '200px' }: UseIsVisibleOptions = {}) {
  const elementRef = useRef<Element>(null);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element || hasBeenVisible) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasBeenVisible(true);
        }
      },
      { rootMargin },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [hasBeenVisible, rootMargin]);

  return { elementRef, hasBeenVisible };
}
